export default {
    home_page_title: "Información de la Cuenta",
    security_page_title: "Centro de Seguridad",
    security_setting_page_title: "Centro de Seguridad",
    security_phone_label: "Número Móvil",
    security_email_label: "Correo Electrónico",
    security_question_label: "Pregunta de Seguridad",
    security_unset_text: "Sin Configurar",
    security_setted_text: "Establecido",
    security_question_options: [
        "¿Cómo se llama tu mamá?",
        "¿Cuándo es el cumpleaños de tu esposa?",
        "¿Cómo se llama tu papá?",
        "¿Cuál es tu número de estudiante o trabajador?",
        "¿Cómo se llama tu mejor amigo de la infancia?",
        "¿Cómo se llama tu personaje favorito?"
    ],
    password_lost_page_title: "Olvidé Contraseña",
    password_reset_page_title: "Restaurar Contraseña",
    password_lost_account_placeholder:
        "Introduzca la Cuenta en que ha olvidado su Contraseña",
    empty_lost_account_tips: "La cuenta no puede ser vacía",
    iscorrect_lost_account_tips: "Cuenta Inexistente",
    password_reset_new_placeholder: "Nueva Contraseña",
    password_reset_confirm_placeholder: "Confirmar nueva Contraseña",
    password_verify_page_title: "Verificar Identidad",
    phone_verify_page_title: "Verificar Identidad",
    email_verify_page_title: "Verificar Identidad",
    question_verify_page_title: "Verificar Identidad",
    phone_reset_page_title: "Número Móvil",
    email_reset_page_title: "Correo Electrónico",
    question_reset_page_title: "Pregunta de Seguridad",
    phone_binding_text: "Vincular su número de teléfono móvil",
    email_binding_text: "Su Correo vinculado es",
    verification_code_text: "Código Verificación",
    resend_text: "Reenviar",
    empty_phone_number_tips: "Ingresa Número Móvil",
    iscorrect_phone_number_tips:
        "Por favor, introduce el formato correcto del número de teléfono móvil.",
    empty_verification_code_tips: "Ingresa Código",
    iscorrect_verification_code_tips: "Código Erróneo",
    password_placeholder: "Contraseña",
    empty_password_tips: "Por favor introduzca su contraseña",
    iscorrect_password_tips: "Error de Contraseña",
    mismatched_rule_password_tips:
        "La contraseña no se puede contener &, # y espacios.",
    different_confirm_password_tips: "Contraseña inconsistente",
    empty_email_tips: "Introduzca el Correo",
    iscorrect_email_tips: "Correo Incorrecto",
    answer_placeholder: "Responder",
    empty_question_tips: "Elige Pregunta Seguridad",
    empty_answer_tips: "Introduce Respuesta",
    iscorrect_answer_tips: "Respuesta Incorrecta",
    next_step_text: "Siguiente",
    submit_text: "Enviar",
    submit_success_tips: "Establecer Exitoso",
    submit_error_tips: "La operación ha fallado, vuelva a intentarlo",
    get_data_fail_tips: "Internet error, vuelva a intentar más tarde.",
    use_other_verification_type_text: "Otro tipo de verificación",
    custom_support_notice:
        "La cuenta no se vincula a preguntas de seguridad, favor dar clic al link siguiente a reclamar en tu PC" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
